import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Stack, Typography } from '@mui/material';

import { Button } from '@/components/ui/button.tsx';

import { MutationButton } from '../../../../MutationButton.tsx';
import { content } from './VorschlaegePruefenHeader.content';

export type VorschlaegePruefenHeaderProps = {
  readonly modulLabel?: string;
  readonly canUebernehmen?: boolean;
  readonly isUebernehmenPending?: boolean;
  readonly isVerwerfenDisabled?: boolean;
  readonly isCloseDisabled?: boolean;
  readonly canAuswahlAufheben?: boolean;
  readonly isAuswahlAufhebenPending?: boolean;
  readonly onAuswahlAufheben: () => void | Promise<void>;
  readonly onUebernehmen: () => void | Promise<void>;
  readonly onVerwerfenAndUmplanen: () => void;
  readonly onClose: () => void | Promise<void>;
};

export const VorschlaegePruefenHeader = ({
  modulLabel,
  canUebernehmen = false,
  isUebernehmenPending = false,
  isVerwerfenDisabled = false,
  isCloseDisabled = false,
  canAuswahlAufheben,
  isAuswahlAufhebenPending,
  onAuswahlAufheben,
  onUebernehmen,
  onVerwerfenAndUmplanen,
  onClose,
}: VorschlaegePruefenHeaderProps) => (
  <Stack
    direction="row"
    sx={{
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
      px: 3,
      py: 2,
      borderBottom: 1,
      borderColor: 'divider',
    }}
  >
    <Typography variant="headingXs">{modulLabel ? `${modulLabel}: ${content.titel}` : content.titel}</Typography>
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1.5 }}>
      <Button
        label={content.buttons.verwerfenUndUmplanen}
        variant="secondary"
        size="compact"
        disabled={isVerwerfenDisabled || isUebernehmenPending || isAuswahlAufhebenPending}
        onClick={onVerwerfenAndUmplanen}
      />
      {canAuswahlAufheben && (
        <MutationButton
          label={content.buttons.auswahlAufheben}
          variant="tertiary"
          size="compact"
          disabled={isVerwerfenDisabled || isUebernehmenPending || isAuswahlAufhebenPending}
          loading={isAuswahlAufhebenPending}
          onClick={() => void onAuswahlAufheben()}
        />
      )}
      <MutationButton
        label={content.buttons.uebernehmen}
        variant="primary"
        size="compact"
        disabled={!canUebernehmen || isUebernehmenPending || isAuswahlAufhebenPending}
        loading={isUebernehmenPending}
        onClick={() => void onUebernehmen()}
      />
      <IconButton
        size="small"
        aria-label={content.buttons.schliessen}
        disabled={isCloseDisabled}
        sx={{ border: '1px solid lightgrey', borderRadius: '50%' }}
        onClick={() => void onClose()}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Stack>
  </Stack>
);
